import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Popover from 'components/common/Popover'
import Theme from 'components/common/Theme/Theme'
import { TOOLTIPS } from 'components/common/Popover/constants'
import { Cell, PriceCell, ItemText } from './CommonStyles'
import { GrayCheckbox } from '../../../../Common.styles'


const OTDPItem = ({
  genericId,
  price = 0,
  brand: name,
  handlePopoverClick,
  label,
  displayCheckbox,
  mandatory,
  ...props
}) =>
  <Table mandatory={ mandatory }>
    <Cell width="70">
      {
        displayCheckbox ?
          <GrayCheckbox { ...props } label={ label } margin="0" id={ genericId }>
            {/* eslint-disable */}
            { TOOLTIPS[name] &&
            <span role="button" onClick={ handlePopoverClick }>
              <CheckBoxPopover info={ TOOLTIPS[name] } data-at-tpms-tooltip />
            </span>
            }
            {/* eslint-enable */}
          </GrayCheckbox> :
          <Fragment>
            <ItemText>
              { label }
            </ItemText>
            {/* eslint-disable */}
            { TOOLTIPS[name] &&
            <span onClick={ handlePopoverClick }>
              <CheckBoxPopover info={ TOOLTIPS[name] } data-at-tpms-tooltip />
            </span>
            }
            {/* eslint-enable */}
          </Fragment>
      }
    </Cell>
    <PriceCell width="30">
      ${ price.toFixed(2) }
    </PriceCell>
  </Table>

OTDPItem.propTypes = {
  brand: PropTypes.string,
  displayCheckbox: PropTypes.bool,
  genericId: PropTypes.string,
  handlePopoverClick: PropTypes.func,
  label: PropTypes.string,
  mandatory: PropTypes.bool,
  price: PropTypes.number
}

export default OTDPItem


const Table = styled.div`
  position: relative;
  padding: 10px 0;
  margin-bottom: 10px;
  overflow-x: hidden;
  display: table;
  table-layout: fixed;
  width: 100%;
  ${props => props.mandatory && css`
    border-bottom: 1px solid ${Theme.colors.light_grey};
    padding: 5px 0;
  `}
`

const CheckBoxPopover = styled(Popover)`
  margin-left: 5px;
  display: inline-block;

  img {
    width: 15px;
  }
`
